// components/common/WidgetCard.jsx
export default function WidgetCard({ title, children, className = "" }) {
  return (
    <div className={`bg-white rounded-lg border p-0 overflow-hidden h-full flex flex-col ${className}`}>
      {/* 타이틀 영역 */}
      <div className="px-4 py-2 bg-[#1e1e2f]">
        <h3 className="text-white text-sm">{title}</h3>
      </div>

      {/* 내용 영역 - 패딩 최소화 */}
      <div className="p-3 flex-1">
        {children}
      </div>
    </div>
  );
}
